import { writable } from 'svelte/store';

const initialData = {
  currentDistributor: null,
  distributors: null
}

export const DistributorStore = writable(initialData);

// functions
export const distributorReset = () => DistributorStore.set(initialData);
